import React, { useMemo } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import StyledBox from 'views/rebranded-module/location-module/LocationsViewV2/components/LocationsSection/LocationsSection.styles';
import {
  DesktopLocationList,
  MobileLocationList,
} from 'views/rebranded-module/location-module/LocationsViewV2/components';

const LocationsSection = (props) => {
  const {
    usCountry,
    filteredUsLocations,
    filteredNonUsLocations,
    filter,
    expandAccordion,
    defaultVehicleType,
    content,
  } = props;
  const theme = useTheme();
  const isCrawler = useSelector((state) => state.globalData.isCrawler);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.up('sm'));
  const shouldRenderMobile = useMemo(() => {
    if (isCrawler) return true;
    return isMobile;
  }, [isMobile]);
  const shouldRenderDesktop = useMemo(() => {
    if (isCrawler) return true;
    return isTablet;
  }, [isTablet]);

  return (
    <StyledBox>
      {/* desktop Locations */}
      {shouldRenderDesktop && (
        <DesktopLocationList
          usCountry={usCountry}
          filter={filter}
          filteredNonUsLocations={filteredNonUsLocations}
          filteredUsLocations={filteredUsLocations}
          defaultVehicleType={defaultVehicleType}
          content={content}
        />
      )}

      {/* Mobile accorddin */}
      {shouldRenderMobile && (
        <MobileLocationList
          usCountry={usCountry}
          filter={filter}
          filteredNonUsLocations={filteredNonUsLocations}
          filteredUsLocations={filteredUsLocations}
          expandAccordion={expandAccordion}
          defaultVehicleType={defaultVehicleType}
          content={content}
        />
      )}
    </StyledBox>
  );
};

export { LocationsSection };
